const FLAGS_SPRITE_URL =
  'https://www.paypalobjects.com/digitalassets/c/website/marketing/global/shared/global/country-worldwide/sprite_countries_flag5.png'; // eslint-disable-line max-len

export { FLAGS_SPRITE_URL };
